import type { LexicalEditor } from 'lexical';

import type { LanguageEnum } from 'js/src/client';
import type { PlainJsStoreOrmData } from 'js/src/data/plain-js-store-orm';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { TranslatedEditorsType } from 'js/src/data/translated-editors/translated-editors-types';
import type { RootState } from 'js/src/libs/RootState';

export function getTranslatedEditors(state: RootState) {
    return state.transcript_translations.translated_editors;
}

// currently we only ever interact with 1 lang code so this selector is just convenience
// if we move toward storing multiple translations we should write a different
// selector for that purpose
export function getTranslatedLangCodeFromSceneGroupId(
    state: RootState,
    sceneGroupId: string,
): LanguageEnum | undefined {
    return _getLangCodeFromSceneGroupId(getTranslatedEditors(state), sceneGroupId);
}

function _getLangCodeFromSceneGroupId(
    translatedEditors: PlainJsStoreOrmData<TranslatedEditorsType, string>,
    sceneGroupId: string,
): LanguageEnum | undefined {
    const translatedEditorsData = new PlainJsStoreORM(translatedEditors).getById(sceneGroupId);
    if (translatedEditorsData) {
        return Object.keys(translatedEditorsData.translations)[0] as LanguageEnum | undefined;
    }
}

export function getAllTranslatedEditorsSceneGroupIds(state: RootState): readonly string[] {
    return getTranslatedEditors(state).allIds;
}

export function getSceneGroupIdsWithTranslation(state: RootState): readonly string[] {
    return getTranslatedEditors(state).allIds;
}

export function getActiveTranslationSceneGroupId(state: RootState) {
    return state.transcript_translations.active_translation_scene_group_id;
}

export function getTranslatedEditorBySceneGroupId(
    state: RootState,
    sceneGroupId: string,
): LexicalEditor | undefined {
    return _getTranslatedEditorBySceneGroupId(getTranslatedEditors(state), sceneGroupId);
}

function _getTranslatedEditorBySceneGroupId(
    translatedEditors: PlainJsStoreOrmData<TranslatedEditorsType, string>,
    sceneGroupId: string,
): LexicalEditor | undefined {
    // not every scene group has translations
    const translatedEditorsData = new PlainJsStoreORM(translatedEditors).getById(sceneGroupId);
    if (!translatedEditorsData) {
        return;
    }
    const langCode = _getLangCodeFromSceneGroupId(translatedEditors, sceneGroupId);
    if (!langCode) {
        return;
    }
    return translatedEditorsData.translations[langCode].editor;
}
